import React from "react";
import CostCenterList from "./CostCenterList";
import RemovableCostCenterLabel from "components/Removables/RemovableCostCenter";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";

const CostCenterModalPicker = (props: ModalPickerProps<server.dto.CostCenter>) => {
  const onChange = (value: server.dto.CostCenter) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={RESX.CostCenter.CostCenters}
    modalSize="tiny"
    renderModalContent={(closeModal) => <CostCenterList
      onItemSelected={(costCenter) => {
        closeModal();
        onChange(costCenter);
      }}
    />}
    renderRemovable={RemovableCostCenterLabel}
    {...props}
  />;
};

export default CostCenterModalPicker;